export const DEFAULT_TOOLBAR_TINT_COLOR = (): string | undefined => undefined;
export const DEFAULT_TOOLBAR_BACKGROUND_COLOR = (): string | undefined => undefined;
export const DEFAULT_DESTRUCTIVE_COLOR = (): string | undefined => undefined;
